import { useMemo, useState } from 'react';
import { Button, Grid, Group, Modal } from '@mantine/core';
import SearchableCombobox from '../SearchableCombobox';

const AddCustomFieldModal = ({ availableCustomFields, show, save, close }) => {
  const [field, setField] = useState();

  const submitForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    save(
      {
        name: `Custom field: ${field}`,
        field: field.split('.').slice(1, field.split('.').length).join('.'),
        type: field.split('.')[0],
      },
      close
    );
  };

  const fieldOptions = useMemo(() => {
    if (!availableCustomFields) return [];
    return availableCustomFields.map((field) => {
      const fieldKey = `${field.type}.${field.key}`;
      return {
        value: fieldKey,
        label: `${field.key} (${field.type})`,
      };
    });
  }, [availableCustomFields]);

  if (!availableCustomFields) {
    return '';
  }

  return (
    <Modal opened={show} onClose={() => close()} title="Add Custom Rule">
      <form onSubmit={(e) => submitForm(e)}>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>Field</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <SearchableCombobox
              value={field}
              onChange={(value) => setField(value)}
              options={fieldOptions}
              placeholder="Select a field"
            />
          </Grid.Col>
        </Grid>
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={() => close()}>
            Close
          </Button>
          <Button type="submit" disabled={!field}>
            Save Changes
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default AddCustomFieldModal;
